import React, { FunctionComponent } from 'react';
import { Button, Icon, Popup } from 'semantic-ui-react';
import { Review } from '../types/review.type';
import { getReviewSiteUrl } from '../utils/getReviewSiteUrl';

type ViewReviewOnlineButtonProps = {
  review: Review;
  proViewId?: number;
};

export const ViewReviewOnlineButton: FunctionComponent<
  ViewReviewOnlineButtonProps
> = ({ review, proViewId }) => (
  <Popup
    content="Voir l'avis en ligne"
    position="top center"
    trigger={
      <Button
        basic
        color="grey"
        icon
        onClick={(): void => {
          window.open(getReviewSiteUrl(review, proViewId), '_blank');
        }}
      >
        <Icon name="eye" />
      </Button>
    }
  />
);
